export const SHOW_TOAST = 'SHOW_TOAST';

export const showToast = (severity, summary, detail) => ({
    type: SHOW_TOAST,
    payload: { severity, summary, detail },
});
